import React, { useCallback } from 'react';
import { StyledInput, StyledLabel } from './RadioButton.style';

const RadioButton = ({ option, value, styled, onChange }) => {
  const handleCheck = useCallback(() => {
    onChange(option.id);
  }, [onChange, option.id]);

  return (
    <>
      <StyledInput
        data-testid="radio"
        type="radio"
        id={option.id}
        name="options_list"
        value={option.id}
        disabled={option.disabled}
        checked={value === +option.id}
      />
      <StyledLabel data-testid="radio-label" styled={styled} htmlFor={option.id} onClick={handleCheck}>
        {option.label || option.name}
      </StyledLabel>
    </>
  );
};

RadioButton.displayName = 'RadioButton';
export default RadioButton;
